<template>
  <v-fade-transition>
    <div
      v-show="initSplash"
      id="splash"
      style="opacity:0.85;"
      :style="{backgroundColor:background}"
    >
      <div
        class="content-box"
      >
        <v-img
          v-if="logo"
          class="content"
          :src="`./${logo}`"
          :width="$mq | mq({
            mobile:'50%',
            tablet:'25%',
            desktop:'15%'
          })"
          :style="$mq | mq({
            mobile:'margin:0 25%;',
            tablet:'margin:0 37.5%;',
            desktop:'margin:0 42.5%;'
          })"
        />
        <p class="content">
          <v-icon
            :style="$mq | mq({
              mobile:'margin-top: 20%;',
              tablet:'margin-top: 15%;',
              desktop:'margin-top: 5%;'
            })"
          >
            mdi-loading mdi-spin mdi-48px
          </v-icon>
        </p>
      </div>
    </div>
  </v-fade-transition>
</template>

<script>

export default {
  name: 'SplashScreen',
  data() {
    return {
      background: this.$appConfig.backgroundColor,
      logo: this.$appConfig.logo,
      initSplash: this.$appConfig.showSplash,
      splashTime: this.$appConfig.splashTime,
    };
  },
  created() {
    // removes splash screen after set time
    setTimeout(() => {
      this.initSplash = false;
    }, this.splashTime);
  },
  methods: {},
};

</script>

<style scoped>

  #splash {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }
  .footer-box {
    position: relative;
    bottom: 0;
  }

</style>
